import React, { ClassAttributes, HTMLAttributes, forwardRef } from "react";

import "./modal.css";

export interface ModalHeaderUIProps {}

export type ModalHeaderProps = HTMLAttributes<HTMLElement> &
    ModalHeaderUIProps &
    ClassAttributes<HTMLElement>;

const ModalHeader = forwardRef<HTMLElement, ModalHeaderProps>((props, ref) => {
    const { className, children, ...rest } = props;

    const classes = ["modal-header", className].filter(Boolean).join(" ");

    return (
        <section
            {...rest}
            ref={ref as any}
            className={classes}
        >
            {children}
        </section>
    );
});

ModalHeader.displayName = "ModalHeader";

export default ModalHeader;
